import React from 'react';
import styled from 'styled-components';
import Dn from '../../assets/dn.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';


const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

const Coverbg = styled.img`
  position: absolute;
  max-height: 100%;
  min-width: 100%;
  object-fit: cover;
  align-self:center; 
  border: none;
`;

class CardAlbacore extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Coverbg src= {'https://c402277.ssl.cf1.rackcdn.com/photos/1466/images/story_full_width/tuna_102948248.jpg?1345545852'}/>      
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Dn}
   metricsm="Declining Worldwide"
   diagnosis="Albacore, one of the two main canned tuna species, are threatened by overfishing. Many people depend on this fishery for their livelihood, and nutrition."
   prediction="Tuna are top predators. Like sharks, they play a similar role in balancing the marine ecosystem. An overabundance at lower trophic levels of could deplete resources at the bottom of the food web (WWF)."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardAlbacore;
